export default "__VITE_ASSET__DiB9Xkk$__"